import { BookOpenCheckIcon, FactoryIcon, LightbulbIcon, ScaleIcon, TrendingUpIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Hydrogen & Fuel Cell Technical Dictionary',
    description: 'Essential technical terminology explained for hydrogen and fuel cell technologies.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '2',
    title: 'Hydrogen vs. Battery Energy Storage: Technical Comparison',
    description: 'Understanding how hydrogen and battery storage differ in efficiency, duration, cost, and applications.',
    icon: ScaleIcon,
  },
  {
    number: '3',
    title: 'Hydrogen Technology Myths & Technical Realities',
    description: '16 common misconceptions explained through engineering principles.',
    icon: LightbulbIcon,
  },
  {
    number: '4',
    title: 'Hydrogen Project Economics & Industry Terminology',
    description: 'Understanding CAPEX, OPEX, LCOH, financing, and commercial uncertainties.',
    icon: TrendingUpIcon,
  },
  {
    number: '5',
    title: 'Hydrogen Industry Scenarios & Technology Perspectives',
    description: '12 realistic industrial situations with technical analysis.',
    icon: FactoryIcon,
  },
];
